import type { ReactElement, SVGProps } from 'react';

export default function ChevronRightIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.7802 11.2801C15.9209 11.4206 16 11.6113 16.0002 11.8101V12.1901C15.9979 12.3885 15.919 12.5784 15.7802 12.7201L10.6402 17.8501C10.5463 17.9448 10.4185 17.998 10.2852 17.998C10.1518 17.998 10.024 17.9448 9.93016 17.8501L9.22016 17.1401C9.1261 17.0479 9.07309 16.9218 9.07309 16.7901C9.07309 16.6584 9.1261 16.5323 9.22016 16.4401L13.6702 12.0001L9.22016 7.5601C9.12551 7.46621 9.07227 7.33842 9.07227 7.2051C9.07227 7.07178 9.12551 6.94398 9.22016 6.8501L9.93016 6.1501C10.024 6.05544 10.1518 6.0022 10.2852 6.0022C10.4185 6.0022 10.5463 6.05544 10.6402 6.1501L15.7802 11.2801Z"
        fill="currentColor"
      />
    </svg>
  );
}
